import React, { useRef, useState } from 'react';
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from 'reactstrap';
import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';
import { QrReader } from 'react-qr-reader';
import {
  setAvailableOrderTypes,
  setCheckout,
  setTable,
} from '../../../../redux/store/store.actions';
import { connect } from 'react-redux';
import { notification } from '../../../../utility/notification/notification.service';
import { useMemo } from 'react';
import Lottie from 'lottie-react';
import qrscansuccess from '../../../../assets/lottie/qr-scan-success.json';
import {
  getSession,
  replaceColorInLottie,
  updateTableSession,
} from '../../../../utility/util/util.service';

const OverlaySessionModal = ({
  isOpen,
  closeModal,
  setTable,
  table,
  store,
  setCheckout,
  setAvailableOrderTypes,
}) => {
  const lastScannedQrRef = useRef(null);
  const [cameraPermissionStatus, setCameraPermissionStatus] = useState(null);
  const [cameraPermissionRequested, setCameraPermissionRequested] = useState(
    false,
  );

  const successAnimationFull = useMemo(
    () => (
      <Lottie
        className="justify-content-center"
        style={{ height: '250px', width: '250px' }}
        animationData={replaceColorInLottie(
          qrscansuccess,
          store?.primaryColor || '#22442c',
        )}
        loop={true}
      />
    ),
    [store?.primaryColor],
  );

  const handleButtonClick = () => {
    localStorage.removeItem('tableSession');
    setCheckout(null);
    setAvailableOrderTypes(null);
    setTable(null);
    closeModal(false);
  };

  return (
    <Modal isOpen={isOpen} className="modal-dialog modal-dialog-centered">
      <ModalHeader>
        <FormattedMessage
          id="overlayHeaderTitle"
          values={{
            storeName: store?.name,
          }}
        />
      </ModalHeader>
      <ModalBody>
        <div>
          <FormattedMessage
            id="overlayContentText"
            values={{
              storeName: store?.name,
              tableName: table?.name,
            }}
          />
        </div>

        {cameraPermissionRequested && (
          <div className="d-flex flex-column align-items-center">
            <QrReader
              className="m-2"
              /* videoContainerStyle={{ width: '300px', height: '300px' }} */
              containerStyle={{ width: '300px', height: '300px' }}
              videoStyle={{
                width: 300,
                height: 300,
                borderRadius: '0.5rem',
                border: 'solid',
                borderColor: store?.primaryColor,
                borderWidth: '4px',
              }}
              key="environment"
              constraints={{
                facingMode: 'environment',
                aspectRatio: { ideal: 1 },
              }}
              onResult={(result, error) => {
                if (!!result) {
                  const url = result?.text;
                  const regex = /menu\.sb\/t-(([a-z]|[0-9]){4})/;
                  const match = url.match(regex);
                  if (match) {
                    const slug = match[1];
                    const tableSession = getSession('tableSession');

                    if (slug === tableSession?.table?.slug) {
                      updateTableSession();
                      closeModal(false);
                      lastScannedQrRef.current = null;
                    } else if (url !== lastScannedQrRef.current) {
                      notification('error', 'overlayInvalidQrCode');
                      lastScannedQrRef.current = url;
                    }
                  }
                }

                if (!!error) {
                  console.log(error);
                  console.log(cameraPermissionStatus);
                }
              }}
            />
          </div>
        )}

        {!cameraPermissionRequested && (
          <>
            <div className="d-flex flex-column align-items-center">
              {successAnimationFull}
              <Button
                className="mt-2 mb-2"
                color="primary"
                onClick={() => {
                  setCameraPermissionRequested(true);
                }}
              >
                <FormattedMessage id="cameraAccessLabel" />
              </Button>
            </div>
          </>
        )}
      </ModalBody>
      <ModalFooter>
        <Button className="w-100" color="primary" onClick={handleButtonClick}>
          <FormattedMessage id="overlayCloseLabel" />
        </Button>
      </ModalFooter>
    </Modal>
  );
};

OverlaySessionModal.propTypes = {
  isOpen: PropTypes.bool,
  toggleModal: PropTypes.func.isRequired,
  closeModal: PropTypes.func,
  store: PropTypes.object,
  table: PropTypes.object,
};

const mapStateToProps = (state) => ({
  store: state.store.store,
  table: state.store.table,
});

export default connect(mapStateToProps, {
  setTable,
  setCheckout,
  setAvailableOrderTypes,
})(OverlaySessionModal);
